import { http } from "../http-common";

interface AttributeListParams {
  reportFormatsFilter?: "all" | "with" | "without";
  preparationTextFilter?: "all" | "with" | "without";
}

interface InspectorAttributeListParams {
  page?: number;
  size?: number;
  sort?: string;
  search?: string;
}

const getAll = (params?: AttributeListParams) => {
  const query = new URLSearchParams();
  if (params?.reportFormatsFilter && params.reportFormatsFilter !== "all") {
    query.set("reportFormatsFilter", params.reportFormatsFilter);
  }
  if (params?.preparationTextFilter && params.preparationTextFilter !== "all") {
    query.set("preparationTextFilter", params.preparationTextFilter);
  }
  const suffix = query.toString();
  const url = suffix ? `/attributes?${suffix}` : "/attributes";
  return http.get<Array<any>>(url);
};

const getAllActive = () => {
  return http.get<Array<any>>("/attributes?active=true");
};

const getInspectorAttributes = (params?: InspectorAttributeListParams) => {
  return http.get<any>("/attributes/me/inspector", {
    params: {
      page: params?.page ?? 0,
      size: params?.size ?? 1000,
      sort: params?.sort ?? "order,asc",
      ...(params?.search ? { search: params.search } : {}),
    },
  });
};

const getAllTypes = () => {
  return http.get<Array<any>>("/types");
};

const get = (id: Number) => {
  return http.get<any>(`/attributes/${id}`);
};

const create = (data: any) => {
  return http.post<any>("/attributes", data);
};

const update = (id: any, data: any) => {
  return http.put<any>(`/attributes/${id}`, data);
};

const remove = (id: any) => {
  return http.delete<any>(`/attributes/${id}`);
};

const updateOrder = (data: any) => {
  return http.post<any>("/attributes/updateOrder", data);
};

const AttributeService = {
  getAll,
  get,
  create,
  update,
  remove,
  getAllActive,
  getInspectorAttributes,
  getAllTypes,
  updateOrder
};

export default AttributeService;
